import React, { useState } from "react";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import { IoChevronForwardOutline, IoChevronBackOutline } from "react-icons/io5";
import { isBrowser, isMobile } from "react-device-detect";

export default function PodcastTop({ podcasts }) {
	const navigate = useNavigate();
	const [loading, setLoading] = useState(true);
	const [invalid, setInvalid] = useState(false);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [touchPosition, setTouchPosition] = useState(null);
	const { innerWidth: width } = window;
	const carouselItemsLength = 10;
	const itemMobileShownQty = 3;
	const itemDesktopShownQty = 5;
	const itemWidth = isBrowser ? 20 : 33.33;
	const loadingSize = width > 769 ? 30 : 3;
	const podcastsSliced = podcasts.slice(0, carouselItemsLength);
	const handleOnClick = (idseries) => {
		navigate(`/podcast/${idseries}`);
	};
	const handleTouchStart = (e) => {
		const touchDown = e.touches[0].clientX;
		setTouchPosition(touchDown);
	};

	const prev = () => {
		if (currentIndex > 0) {
			setCurrentIndex((prevState) => prevState - 1);
		}
	};
	const next = () => {
		if (currentIndex < carouselItemsLength - itemMobileShownQty && isMobile) {
			setCurrentIndex((prevState) => prevState + 1);
		} else if (currentIndex < carouselItemsLength - itemDesktopShownQty && isBrowser) {
			setCurrentIndex((prevState) => prevState + 1);
		}
	};
	const handleTouchMove = (e) => {
		const touchDown = touchPosition;
		if (touchDown === null) {
			return;
		}
		const currentTouch = e.touches[0].clientX;
		const diff = touchDown - currentTouch;
		const diffToGoNext = 5;
		const diffToGoPrev = -5;
		if (diff > diffToGoNext) {
			next();
		}
		if (diff < diffToGoPrev) {
			prev();
		}
		setTouchPosition(null);
	};
	return (
		<div className="carousel-container">
			{currentIndex > 0 && isBrowser && (
				<button onClick={prev} className="left-arrow-top">
					<IoChevronBackOutline
						size={50}
						color={"white"}
						onMouseOver={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onClick={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onMouseOut={({ target }) => (target.style.color = "white")}
					/>
				</button>
			)}
			<div className="carousel-content-wrapper-top" onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
				<div
					className="carousel-content-top"
					style={{ transform: `translateX(-${currentIndex * 100}%`, width: `${itemWidth}%` }}
				>
					{podcastsSliced.map((item, index) => (
						<div
							key={item?.title?.toString() + index}
							id={`podcast${item?.rpId}`}
							onClick={(e) => handleOnClick(item.idseries)}
						>
							<div
								className="carousel-pict ms-1 ms-md-3"
								style={{
									backgroundImage: loading && !invalid ? null : `url(${item?.imageUrl})`,
								}}
							>
								<Loading
									size={loadingSize}
									color="red"
									conClass="podcastAlauneLoading-top"
									style={{
										opacity: loading && !invalid ? 1 : 0,
										position: "absolute",
										top: "50%",
										height: "30px",
										zIndex: "99",
									}}
								/>
								<img
									alt={item.title}
									src={item?.imageUrl}
									className="d-block w-100 slider-picture"
									style={{ opacity: 0 }}
									onLoad={() => setLoading(false)}
									onError={() => setInvalid(true)}
								/>
							</div>
						</div>
					))}
				</div>
			</div>
			{currentIndex < carouselItemsLength - itemDesktopShownQty && isBrowser && (
				<button onClick={next} className="right-arrow-top">
					<IoChevronForwardOutline
						size={50}
						color={"white"}
						onMouseOver={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onClick={({ target }) => (target.style.color = "rgba(227, 227, 227, 0.8)")}
						onMouseOut={({ target }) => (target.style.color = "white")}
					/>
				</button>
			)}
		</div>
	);
}
